import $ from 'jquery';
import slideshow from './grouped-tiles-slideshow';
import { registerLaunchers } from './gallery-dialog';

// Try to remove the protocol that the editor sets
const regex = /(^.*\/\/){1}/g;
const url = '/h/gallery/ShowStandaloneMediaGallery';
const selectorPrefix = '#standalone-media-gallery--';

$(_ => {

  // When DOM's ready, look for ObjectTemplate-placed
  // anchors and replace them via ajax

  $('a.js-media-gallery-inserter').each(function() {
    const $el = $(this);
    let slug  = $el.attr('href');

    if (slug) {
      slug = slug.replace(regex, '');
    }

    if (slug) {
      $.get(url, {slug}, html => {

        $el.replaceWith(html);

        registerLaunchers();

        slideshow(selectorPrefix + slug);

      });
    } else {
      $el.remove();
    }
  });

});
